import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

const LogoOverlay = () => {
	const map = useMap();

	useEffect(() => {
		const control = L.control({ position: "bottomleft" });

		control.onAdd = () => {
			// Contenitore principale per il logo
			const container = L.DomUtil.create("div", "leaflet-control-container");
			container.style.position = "relative";
			container.style.display = "flex";
			container.style.flexDirection = "column";
			container.style.alignItems = "flex-start";
			container.style.padding = "2px";
			container.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
			container.style.borderRadius = "8px";
			container.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";

			// Immagine del logo
			const logoImg = L.DomUtil.create("img", "logo-image", container);
			logoImg.src = "/images/solo_logo.svg";
			logoImg.alt = "Logo";
			logoImg.style.width = "50px";
			logoImg.style.height = "auto";
			logoImg.style.display = "block";

			return container;
		};

		control.addTo(map);

		return () => map.removeControl(control);
	}, [map]);

	return null;
};

export default LogoOverlay;
